/**
 * Created by don on 9/15/15.
 */
"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var PublicationAttribute;

PublicationAttribute = SoaModel.extend({

}, {
    MERCHANDISE_PENDING_AUTH: 'MERCHANDISE_PENDING_AUTH',
    MERCHANDISE_PUBLISHED_AUTH: 'MERCHANDISE_PUBLISHED_AUTH',
    CATEGORY : 'CATEGORY',
    DISPLAY_PROMOTE_DEMOTE: 'DISPLAY_PROMOTE_DEMOTE'
});

module.exports = PublicationAttribute;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/PublicationAttribute.js
// module id = 1624
// module chunks = 64